import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Row, Spin, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import orderApi from '../../api/order.api'
import { userState } from '../../store/user'
import '../../styles/sales.module.scss'
import styles from '../../styles/sales.module.scss'

const SalesDeliveryDashboard = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [orderLoading, setOrderLoading] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({
    depositOrder: 0,
    delivery12: 0,
    delivery24: 0,
    deliveryShipping7delay: 0,
    newOrder: 0,
    deliveryReady: 0,
    deliveryShipping: 0,
    deliveryComplete: 0,
  })

  const getOrderDeliveryStatus = async () => {
    try {
      const res = await orderApi.salesManageStatus(null, user.id)
      // console.log('getOrderDeliveryStatus res,:', res)
      if (res.data.code === 200) {
        setOrderDeliveryStatus({
          ...orderDeliveryStatus,
          depositOrder: res.data.result.depositOrderCnt,
          newOrder: res.data.result.paidOrderList.length ?? 0,
          deliveryReady: res.data.result.deliveryReadyList.length ?? 0,
          deliveryShipping: res.data.result.deliveryShippingList.length ?? 0,
          deliveryComplete: res.data.result.deliveryCompleteList.length ?? 0,
          delivery12: res.data.result.deliveryReadyListPassed12.length ?? 0,
          delivery24: res.data.result.deliveryReadyListPassed24.length ?? 0,
        })
      }
    } catch (e) {
      console.log('getOrderDeliveryStatus e', e)
    } finally {
      setOrderLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getOrderDeliveryStatus()
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 500)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <Flex
      vertical
      gap={15}
      style={{ minWidth: '420px', height: '100%', borderWidth: '0' }}
      className={`home-dashboard-component ${isLoading ? 'container-disable' : ''}`}
    >
      {orderLoading && (
        <Spin
          className={'home-dashboard-loading'}
          indicator={<LoadingOutlined spin />}
          size={'large'}
        />
      )}
      <Flex align={'center'} gap={4} className={'home-dashboard-title'}>
        <h2>판매/배송</h2>
        <p className={'title-info-text'}>최근 14일 기준</p>
      </Flex>
      <div
        style={{
          width: '100%',
          padding: '1rem',
          flexDirection: 'row',
          paddingBottom: '12px',
        }}
      >
        <div
          className={`order-component-each main-component-sell`}
          style={{
            gap: '1%',
            display: 'flex',
            flexDirection: 'row',
            // alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <>
            <Row
              className={`${styles['dash-cursor']}`}
              // align={'middle'}
              style={{
                gap: '8px',
                rowGap: '8px',
                width: '20%',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
              }}
              onClick={() => {
                navigate('/order/confirm?type=paid')
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: '1.8rem',
                }}
              >
                {orderDeliveryStatus.newOrder ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: 'fit-content',
                  }}
                >
                  결제완료
                </span>
              </div>
            </Row>
            <img
              style={{ height: 20, width: 20, alignSelf: 'center' }}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
            />
            <Row
              className={`${styles['dash-cursor']}`}
              // align={'middle'}
              style={{
                gap: '8px',
                rowGap: '8px',
                width: '20%',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
              }}
              onClick={() => {
                navigate('/order/confirm?type=delivery_ready')
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignContent: 'center',
                  textAlign: 'center',
                }}
              >
                <h4
                  className={`order-each-detail-title`}
                  style={{
                    fontSize: '1.8rem',
                    marginBottom: '4px',
                  }}
                >
                  {orderDeliveryStatus.deliveryReady ?? 0}
                </h4>
                <div className={`main-dashboard-text-div`}>
                  <span
                    style={{
                      width: 'fit-content',
                    }}
                  >
                    배송준비중
                  </span>
                </div>
              </div>
              <div
                className={`delivery-detail-div`}
                style={{ textAlign: 'center' }}
              >
                <Tooltip
                  title={`배송 준비중 12시간 이상 주문건 총합`}
                  trigger={`click`}
                  overlayStyle={{
                    whiteSpace: 'pre-wrap',
                    fontSize: '0.75rem',
                  }}
                  overlayInnerStyle={{
                    textAlign: 'center',
                  }}
                >
                  <span
                    style={{
                      color: '#ff8000',
                      paddingRight: '0.25rem',
                      cursor: 'pointer',
                    }}
                  >
                    {orderDeliveryStatus?.delivery12 ?? 0}
                  </span>
                </Tooltip>
                /
                <Tooltip
                  title={`배송 준비중 24시간 이상 주문건 총합`}
                  trigger={`click`}
                  overlayStyle={{
                    whiteSpace: 'pre-wrap',
                    fontSize: '0.75rem',
                  }}
                  overlayInnerStyle={{
                    textAlign: 'center',
                  }}
                >
                  <span
                    style={{
                      color: '#df1d1d',
                      paddingLeft: '0.25rem',
                      cursor: 'pointer',
                    }}
                  >
                    {orderDeliveryStatus?.delivery24 ?? 0}
                  </span>
                </Tooltip>
              </div>
            </Row>
            <img
              style={{ height: 20, width: 20, alignSelf: 'center' }}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
            />

            <Row
              className={`${styles['dash-cursor']}`}
              // align={'middle'}
              style={{
                gap: '8px',
                rowGap: '8px',
                width: '20%',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
              }}
              onClick={() => {
                navigate('/order/confirm?type=delivery_shipping')
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignContent: 'center',
                  textAlign: 'center',
                }}
              >
                <h4
                  className={`order-each-detail-title`}
                  style={{
                    fontSize: '1.8rem',
                    marginBottom: '4px',
                  }}
                >
                  {orderDeliveryStatus.deliveryShipping ?? 0}
                </h4>
                <div className={`main-dashboard-text-div`}>
                  <span
                    style={{
                      width: 'fit-content',
                    }}
                  >
                    배송중
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '0.25rem',
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    color: '#df1d1d',
                    textAlign: 'center',
                  }}
                >
                  {orderDeliveryStatus.deliveryShipping7delay ?? 0}
                </span>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Tooltip
                    title={`최근 30일 기준\n배송 일주일 이상 지연 대상`}
                    trigger={`click`}
                    overlayStyle={{
                      whiteSpace: 'pre-wrap',
                      fontSize: '0.75rem',
                    }}
                    overlayInnerStyle={{
                      textAlign: 'center',
                    }}
                  >
                    <img
                      src={`${process.env.REACT_APP_HOST}/assets/icon/common/warning.png`}
                      alt={`warning-icon`}
                      style={{
                        width: '1em',
                        height: '1em',
                        cursor: 'pointer',
                      }}
                      onClick={(e) => {
                        e.stopPropagation()
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </Row>
            <img
              style={{ height: 20, width: 20, alignSelf: 'center' }}
              src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
            />
            <Row
              className={`${styles['dash-cursor']}`}
              // align={'middle'}
              style={{
                gap: '8px',
                rowGap: '8px',
                width: '20%',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
              }}
              onClick={() => {
                navigate('/order/confirm?type=delivery_complete')
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: '1.8rem',
                  textAlign: 'center',
                }}
              >
                {orderDeliveryStatus.deliveryComplete ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: 'fit-content',
                  }}
                >
                  배송완료
                </span>
              </div>
            </Row>
          </>
        </div>
      </div>
    </Flex>
  )
}
export default SalesDeliveryDashboard
